import { render } from "./PaginationDynamic.vue?vue&type=template&id=903f30f2"
import script from "./PaginationDynamic.vue?vue&type=script&lang=js"
export * from "./PaginationDynamic.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__